import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import TierBenefitUpgradeCta from './TierBenefitUpgradeCta';

export default withRouter(withUser(TierBenefitUpgradeCta));
